// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".credit-info[data-v-7d480721]{border-radius:6px;margin-right:20px;vertical-align:middle;white-space:nowrap}.credit-info .money[data-v-7d480721]{background-color:#fdcc0e;border-radius:3px;display:inline-block;font-weight:500;padding:2px 5px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
